export default {"src":"/_next/static/media/pro-promise-review.00760a8b.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};